import Vue from "vue";

export const store = Vue.observable({
    isNavOpen: false,
    isSidebarShowing: false
});

export const mutations = {
    toggleNav() {
        store.isNavOpen = !store.isNavOpen;
    },
    toggleBar() {
        store.isSidebarShowing = !store.isSidebarShowing;
    }
};
export default store;